
import { Options, Vue } from 'vue-class-component'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';

@Options({
  props: {
    errorCode: Number,
    refCode: String,
    onRefresh: Function
  },
  components: {
    QSkeleton
  },
})

export default class Loading extends Vue {

}
